export { IFiltersState, FiltersReducer } from './filters.reducer';




// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/filters/reducer/index.ts